import { render } from "./NotVerifiedUsersTable.vue?vue&type=template&id=c80fa744&scoped=true&ts=true"
import script from "./NotVerifiedUsersTable.vue?vue&type=script&lang=ts"
export * from "./NotVerifiedUsersTable.vue?vue&type=script&lang=ts"

import "./NotVerifiedUsersTable.vue?vue&type=style&index=0&id=c80fa744&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c80fa744"]])

export default __exports__